import { render, staticRenderFns } from "./SurveyPageView.vue?vue&type=template&id=2ded2d9c&"
import script from "./SurveyPageView.vue?vue&type=script&lang=ts&"
export * from "./SurveyPageView.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyPageView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports